export default __webpack_public_path__ + "static/media/balance-visa-white.8799f291.svg";